import { SEARCH_PAGE } from "../../state/modules/page/constants";
import { buildQueryByFacets } from "../../helpers/url";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getLocation } from "../../state/modules/router/selectors";
import {
  getAdditionalQueryParams,
  getFacets
} from "../../state/modules/search/selectors";
import { getPageName } from "../../state/modules/page/selectors";
import {
  getNextPriceRange,
  isCurrentPriceRangeSelected
} from "../../state/modules/search/priceRangeSelectors";

export const useUpdateRefineParameters = ({ searchTerm }) => {
  const location = useSelector(getLocation);
  const additionalQueryParams = useSelector(getAdditionalQueryParams);
  const facets = useSelector(getFacets);
  const pageName = useSelector(getPageName);
  const nextPriceRange = useSelector(getNextPriceRange);
  const currentPriceRangeSelected = useSelector(isCurrentPriceRangeSelected);

  useEffect(() => {
    const history = require("../../client/history").default;
    const { query, pathname, hash } = location;
    let { search } = location;
    const queryParams = Object.keys(query);

    if (
      pageName === SEARCH_PAGE &&
      !!additionalQueryParams &&
      queryParams?.length === 1 &&
      queryParams[0] === "q"
    ) {
      const additionalRefineParameters = buildQueryByFacets(facets, {
        ...nextPriceRange,
        hasSelectedValues: currentPriceRangeSelected
      });

      if (additionalRefineParameters) {
        search += `&refine=${additionalRefineParameters}`;
        history.replace({
          ...location,
          pathname,
          search,
          hash,
          isPrefilterGenderedSearch: true
        });
      }
    }
  }, [searchTerm]);
};
